function fn_part_ui_dialog() {
    var bg = $("#bgd");
    var body = $("body");

    $(document).on('click', "[data-dialog]", function (e) {
        e.preventDefault();
        var el = $(this);

        $.ajax({
            url: el.data('dialog'),
            dataType: 'json'
        }).done(function (data) {
            $(".part_dialog").find(".content").remove();
            if (!body.find(".part_dialog").length) {
                body.addClass("no-scroll").append('<div class="part_dialog"><button id="bgd"></button></div>');
            }
            body.find(".part_dialog").append(data.template);
            $("#bgd").fadeIn(300);
            var dialog = $(".part_dialog");
            dialog.find(".content").hide().fadeIn(300);
            $(".select").select2();
        });
    });

    $(document).on("click", "#bgd, .part_dialog .icon-close", function () {
        body.removeClass("no-scroll");
        $("#bgd").fadeOut(300);
        $(".part_dialog").find(".content").fadeOut(300);

        setTimeout(function() {
            $(".part_dialog").remove();
        }, 500);
    });
}